<template>
  <div class="report-fee-summary-container animated fadeInRight">
    <el-row class="flex justify-start" :gutter="20">
      <el-col :span="3" class="padding-r-0">
        <select-community-floor ref="selectCommunityFloor" />
      </el-col>
      <el-col :span="21">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('reportFeeSummary.queryCondition') }}</span>
          </div>
          <div class="text item">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-date-picker v-model="reportFeeSummaryInfo.conditions.startDate" type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('reportFeeSummary.selectStartDate')" style="width: 100%"
                  @change="handleDateChange" />
              </el-col>
              <el-col :span="4">
                <el-date-picker v-model="reportFeeSummaryInfo.conditions.endDate" type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('reportFeeSummary.selectEndDate')" style="width: 100%" @change="handleDateChange" />
              </el-col>
              <el-col :span="4">
                <el-input v-model.trim="reportFeeSummaryInfo.conditions.objName"
                  :placeholder="$t('reportFeeSummary.inputRoomNumber')" clearable />
              </el-col>
              <el-col :span="4">
                <el-input v-model.trim="reportFeeSummaryInfo.conditions.ownerName"
                  :placeholder="$t('reportFeeSummary.inputOwnerName')" clearable />
              </el-col>
              <el-col :span="4">
                <el-input v-model.trim="reportFeeSummaryInfo.conditions.link"
                  :placeholder="$t('reportFeeSummary.inputOwnerPhone')" clearable />
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="_queryMethod">
                  <i class="el-icon-search"></i>
                  {{ $t('common.search') }}
                </el-button>
                <el-button @click="_resetMethod">
                  <i class="el-icon-refresh"></i>
                  {{ $t('common.reset') }}
                </el-button>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="margin-top">
              <el-col :span="4">
                <el-select v-model="reportFeeSummaryInfo.conditions.feeTypeCd"
                  :placeholder="$t('reportFeeSummary.selectFeeType')" style="width: 100%" clearable>
                  <el-option v-for="(item, index) in reportFeeSummaryInfo.feeTypeCds" :key="index" :label="item.name"
                    :value="item.statusCd" />
                </el-select>
              </el-col>
              <el-col v-if="reportFeeSummaryInfo.communitys.length > 1" :span="4">
                <el-select v-model="reportFeeSummaryInfo.conditions.communityId"
                  :placeholder="$t('reportFeeSummary.selectCommunity')" style="width: 100%" @change="_changCommunity">
                  <el-option v-for="(item, index) in reportFeeSummaryInfo.communitys" :key="index" :label="item.name"
                    :value="item.communityId" />
                </el-select>
              </el-col>
            </el-row>

            <el-row v-show="reportFeeSummaryInfo.moreCondition" class="margin-top">
              <el-col :span="24">
                <el-checkbox-group v-model="reportFeeSummaryInfo.configIds">
                  <el-checkbox v-for="(item, index) in reportFeeSummaryInfo.feeConfigs" :key="index"
                    :label="item.configId">
                    {{ item.feeName }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <el-card class="box-card margin-top">
          <div slot="header" class="flex justify-between">
            <div>
              <span>年度口径简明统计</span>
              <el-tooltip effect="dark" :content="annualMetricTips.summary" placement="top" popper-class="annual-summary-tip">
                <i class="el-icon-info summary-tip-icon"></i>
              </el-tooltip>
              <span class="summary-subtitle">{{ getAnnualTitle() }}</span>
            </div>
          </div>
          <div class="simple-summary-grid">
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>{{ reportFeeSummaryInfo.annualSummary.year }}年以前历史欠费</span>
                <el-tooltip effect="dark" :content="annualMetricTips.hisOweFee" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value warning">{{ formatMoney(reportFeeSummaryInfo.annualSummary.hisOweFee) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>{{ reportFeeSummaryInfo.annualSummary.year }}年应收</span>
                <el-tooltip effect="dark" :content="annualMetricTips.curReceivableFee" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value">{{ formatMoney(reportFeeSummaryInfo.annualSummary.curReceivableFee) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>{{ reportFeeSummaryInfo.annualSummary.year }}已收（月明细归属）</span>
                <el-tooltip effect="dark" :content="annualMetricTips.currentReceivedFee" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value success">{{ formatMoney(reportFeeSummaryInfo.annualSummary.currentReceivedFee) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>{{ reportFeeSummaryInfo.annualSummary.year }}实收（分摊归属）</span>
                <el-tooltip effect="dark" :content="annualMetricTips.actualReceivedByFeeMonth" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value success">{{ formatMoney(reportFeeSummaryInfo.annualSummary.actualReceivedByFeeMonth) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>{{ reportFeeSummaryInfo.annualSummary.year }}实收（收款时间净额）</span>
                <el-tooltip effect="dark" :content="annualMetricTips.actualReceivedFee" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value success">{{ formatMoney(reportFeeSummaryInfo.annualSummary.actualReceivedFee) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>{{ reportFeeSummaryInfo.annualSummary.year }}应收（缴费明细）</span>
                <el-tooltip effect="dark" :content="annualMetricTips.payDetailReceivableFee" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value">{{ formatMoney(reportFeeSummaryInfo.annualSummary.payDetailReceivableFee) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>{{ reportFeeSummaryInfo.annualSummary.year }}优惠（缴费明细）</span>
                <el-tooltip effect="dark" :content="annualMetricTips.payDetailDiscountFee" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value">{{ formatMoney(reportFeeSummaryInfo.annualSummary.payDetailDiscountFee) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>{{ reportFeeSummaryInfo.annualSummary.year }}账户扣款（缴费明细）</span>
                <el-tooltip effect="dark" :content="annualMetricTips.payDetailWithholdFee" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value">{{ formatMoney(reportFeeSummaryInfo.annualSummary.payDetailWithholdFee) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>{{ reportFeeSummaryInfo.annualSummary.year }}年欠费</span>
                <el-tooltip effect="dark" :content="annualMetricTips.curOweFee" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value danger">{{ formatMoney(reportFeeSummaryInfo.annualSummary.curOweFee) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>总欠费</span>
                <el-tooltip effect="dark" :content="annualMetricTips.totalOweFee" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value danger">{{ formatMoney(reportFeeSummaryInfo.annualSummary.totalOweFee) }}</div>
            </div>
            <div class="simple-summary-item">
              <div class="summary-label">
                <span>年度收费率</span>
                <el-tooltip effect="dark" :content="annualMetricTips.annualRate" placement="top" popper-class="annual-summary-tip">
                  <i class="el-icon-info summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value">{{ formatRate(reportFeeSummaryInfo.annualSummary.actualReceivedFee, reportFeeSummaryInfo.annualSummary.curReceivableFee) }}</div>
            </div>
          </div>
        </el-card>

        <el-card v-if="false" class="box-card margin-top">
          <div slot="header" class="flex justify-between">
            <div>
              <span>{{ $t('reportFeeSummary.feeSummaryTable') }}</span>
              <span class="el-icon-info popover-show" style="cursor: pointer;"></span>
              <span>({{ $t('reportFeeSummary.updateDaily') }})</span>
            </div>
            <div style="float: right;">
              <el-button type="primary" size="small" @click="_exportExcel">
                <i class="el-icon-download"></i>
                {{ $t('common.export') }}
              </el-button>
            </div>
          </div>
          <div class="text item">
            <el-table :data="reportFeeSummaryInfo.fees" border style="width: 100%">
              <el-table-column prop="roomCount" :label="$t('reportFeeSummary.totalRooms')" align="center" />
              <el-table-column prop="feeRoomCount" :label="$t('reportFeeSummary.chargeRooms')" align="center" />
              <el-table-column prop="oweRoomCount" :label="$t('reportFeeSummary.arrearsRooms')" align="center" />
              <el-table-column :label="$t('reportFeeSummary.arrearsFormula')" align="center" colspan="3">
                <el-table-column prop="hisOweFee" :label="$t('reportFeeSummary.historyArrears')" align="center" />
                <el-table-column prop="curOweFee" :label="$t('reportFeeSummary.currentArrears')" align="center" />
                <el-table-column :label="$t('reportFeeSummary.totalArrears')" align="center">
                  <template slot-scope="scope">
                    {{ (scope.row.curOweFee + scope.row.hisOweFee).toFixed(2) }}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column :label="$t('reportFeeSummary.actualPaymentFormula')" align="center" colspan="4">
                <el-table-column prop="hisReceivedFee" :label="$t('reportFeeSummary.arrearsRecovery')" align="center" />
                <el-table-column :label="$t('reportFeeSummary.currentPartial')" align="center">
                  <template slot-scope="scope">
                    {{ (scope.row.receivedFee - scope.row.hisReceivedFee - scope.row.preReceivedFee).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="preReceivedFee" :label="$t('reportFeeSummary.advancePayment')" align="center" />
                <el-table-column prop="receivedFee" :label="$t('reportFeeSummary.actualPayment')" align="center" />
              </el-table-column>
              <el-table-column prop="curReceivableFee" :label="$t('reportFeeSummary.currentReceivable')"
                align="center" />
              <el-table-column :label="$t('reportFeeSummary.currentActual')" align="center">
                <template slot-scope="scope">
                  {{ (scope.row.curReceivableFee - scope.row.curOweFee).toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('reportFeeSummary.roomChargeRate')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.feeRoomCount > 0 ? (((scope.row.feeRoomCount - scope.row.oweRoomCount) /
                    scope.row.feeRoomCount * 100).toFixed(2) + '%') : '0%' }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('reportFeeSummary.chargeRate')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.curReceivableFee > 0 ? (((scope.row.curReceivableFee - scope.row.curOweFee) /
                    scope.row.curReceivableFee * 100).toFixed(2) + '%') : '0%' }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('reportFeeSummary.clearanceRate')" align="center">
                <template slot-scope="scope">
                  {{ (scope.row.hisReceivedFee + scope.row.hisOweFee) > 0 ? ((scope.row.hisReceivedFee /
                    (scope.row.hisReceivedFee + scope.row.hisOweFee) * 100).toFixed(2) + '%') : '0%' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>

        <div class="margin-top">
          <floor-fee-summary ref="floorFeeSummary" />
        </div>
        <div class="margin-top">
          <config-fee-summary ref="configFeeSummary" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDict, getCommunityId } from '@/api/community/communityApi'
import { queryReportFeeSummary, exportData, queryCommunitys, queryFeeConfigs } from '@/api/report/reportFeeSummaryApi'
import SelectCommunityFloor from '@/components/report/selectCommunityFloor'
import FloorFeeSummary from '@/components/report/floorFeeSummary'
import ConfigFeeSummary from '@/components/report/configFeeSummary'

export default {
  name: 'ReportFeeSummaryList',
  components: {
    SelectCommunityFloor,
    FloorFeeSummary,
    ConfigFeeSummary
  },
  data() {
    return {
      reportFeeSummaryInfo: {
        fees: [],
        feeConfigs: [],
        floors: [],
        configIds: [],
        feeTypeCds: [],
        communitys: [],
        moreCondition: false,
          annualSummary: {
            year: new Date().getFullYear(),
            startDate: '',
            endDate: '',
            hisOweFee: 0,
            curOweFee: 0,
            curReceivableFee: 0,
            currentReceivedFee: 0,
            actualReceivedFee: 0,
            actualReceivedByFeeMonth: 0,
            payDetailReceivableFee: 0,
            payDetailDiscountFee: 0,
            payDetailWithholdFee: 0,
          totalOweFee: 0
        },
        conditions: {
          floorId: '',
          objName: '',
          startDate: '',
          endDate: '',
          configId: '',
          feeTypeCd: '',
          ownerName: '',
          link: '',
          communityId: ''
        }
      },
      annualMetricTips: {
        summary: '年度口径固定按所选结束日期所在年份统计，统计期间为当年1月1日至当年12月31日；房屋、业主、费用类型、费用项等查询条件会同步参与过滤。',
        hisOweFee: '统计本年度开始日以前的历史欠费。按费用归属时间小于本年1月1日的欠费月明细汇总，欠费金额按应收金额减已收金额减优惠金额计算，不统计已作废明细。',
        curReceivableFee: '统计本年度应收。按费用归属时间在本年1月1日至12月31日之间的收费明细汇总应收金额，用于表示本年度应收本金。',
        currentReceivedFee: '统计本年度已收（月明细归属）。按费用归属时间在本年度内的月明细已收金额汇总，反映本年度费用被收掉多少，不按实际收款发生日期归集；该金额不和缴费明细表按收款时间的大计直接对账。',
        actualReceivedByFeeMonth: '统计本年度实收（分摊归属）。先取缴费明细中已完成缴费的真实实收金额，再按该笔缴费对应月明细在本年度的已收占比分摊到本年度，适合核对跨年度缴费的真实实收归属；该金额不和缴费明细表按收款时间的大计直接对账。',
        actualReceivedFee: '统计本年度实收（收款时间净额）。按缴费明细的收款时间在本年1月1日至12月31日之间汇总实收金额，正常缴费计入、退费单按负数抵扣，不统计作废或拒绝流水，不按费用所属月份拆分；该金额用于和缴费明细表默认大计对账。',
        payDetailReceivableFee: '缴费明细表大计口径。按缴费明细收款时间在本年度内统计应收金额，默认只统计有效流水：正常缴费1400和退费1300，不统计作废、拒绝或无效流水。',
        payDetailDiscountFee: '缴费明细表大计口径。按缴费明细收款时间在本年度内统计 discount_amount 优惠金额，默认只统计有效流水：正常缴费1400和退费1300，不统计作废、拒绝或无效流水。',
        payDetailWithholdFee: '缴费明细表大计口径。按缴费明细收款时间在本年度内统计 acct_amount 账户扣款金额，默认只统计有效流水：正常缴费1400和退费1300，不统计作废、拒绝或无效流水。',
        curOweFee: '统计本年度欠费。按费用归属时间在本年度内且未结清的欠费月明细汇总，欠费金额按应收金额减已收金额减优惠金额计算。',
        totalOweFee: '总欠费=本年度以前历史欠费+本年度欠费，用于查看截至本年度口径下仍未结清的累计欠费。',
        annualRate: '年度收费率=实收（收款时间净额）/本年度应收*100%。该指标按收款发生时间衡量年度回款比例，退费会按负数抵扣，跨年补缴会计入收款发生年份。'
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      this.reportFeeSummaryInfo.conditions.communityId = await getCommunityId()
      this._initDate()
      this._loadStaffCommunitys()
      this._listFeeConfigs()
      this.getFeeTypeDict()
      this.$refs.selectCommunityFloor.open({
        callBack: (floor) => {
          this.reportFeeSummaryInfo.conditions.floorId = floor.floorId
          this._listFees()
        }
      })
      this._listFees()
    },
    _initDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const lastDay = new Date(year, month, 0).getDate()

      this.reportFeeSummaryInfo.conditions.startDate = `${year}-${month.toString().padStart(2, '0')}-01`
      this.reportFeeSummaryInfo.conditions.endDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay}`
    },
    handleDateChange() {
      if (this.reportFeeSummaryInfo.conditions.startDate && this.reportFeeSummaryInfo.conditions.endDate) {
        const start = new Date(this.reportFeeSummaryInfo.conditions.startDate)
        const end = new Date(this.reportFeeSummaryInfo.conditions.endDate)

        if (start > end) {
          this.$message.error(this.$t('reportFeeSummary.dateError'))
          this.reportFeeSummaryInfo.conditions.endDate = ''
        }
      }
    },
    async getFeeTypeDict() {
      try {
        this.reportFeeSummaryInfo.feeTypeCds = await getDict('pay_fee_config', 'fee_type_cd')
      } catch (error) {
        console.error('Failed to get fee type dict:', error)
      }
    },
    async _listFees() {
      try {
        const params = {
          page: 1,
          row: 100,
          ...this.reportFeeSummaryInfo.conditions,
        }
        if (this.reportFeeSummaryInfo.configIds.length > 0) {
          params.configIds = this.reportFeeSummaryInfo.configIds.join(',');
        }

        await this._queryAnnualSummary(params)
        this.reportFeeSummaryInfo.fees = []

        // 通知子组件查询（子组件内部自己查询）
        if (this.$refs.floorFeeSummary) {
          this.$refs.floorFeeSummary.notify(params)
        }
        if (this.$refs.configFeeSummary) {
          this.$refs.configFeeSummary.notify(params)
        }
      } catch (error) {
        console.error('Failed to query fee summary:', error)
        this.$message.error(this.$t('reportFeeSummary.queryFailed') || '查询失败，请稍后重试')
      }
    },
    async _queryAnnualSummary(baseParams) {
      const year = this.getSummaryYear()
      const endDate = this.getSummaryEndDate(year)
      const annualParams = {
        ...baseParams,
        startDate: `${year}-01-01`,
        endDate
      }
      const { data } = await queryReportFeeSummary(annualParams)
      const summary = data && data.length > 0 ? data[0] : {}
      const hisOweFee = Number(summary.hisOweFee || 0)
      const curReceivableFee = Number(summary.curReceivableFee || 0)
      const currentReceivedFee = Number(summary.currentReceivedFee || 0)
      const actualReceivedFee = Number(summary.receivedFee || 0)
      const actualReceivedByFeeMonth = Number(summary.actualReceivedByFeeMonth || 0)
      const payDetailReceivableFee = Number(summary.payDetailReceivableFee || 0)
      const payDetailDiscountFee = Number(summary.payDetailDiscountFee || 0)
      const payDetailWithholdFee = Number(summary.payDetailWithholdFee || 0)
      const curOweFee = Number(summary.curOweFee || 0)

      this.reportFeeSummaryInfo.annualSummary = {
        year,
        startDate: annualParams.startDate,
        endDate,
        hisOweFee,
        curOweFee,
        curReceivableFee,
        currentReceivedFee,
        actualReceivedFee,
        actualReceivedByFeeMonth,
        payDetailReceivableFee,
        payDetailDiscountFee,
        payDetailWithholdFee,
        totalOweFee: hisOweFee + curOweFee
      }
    },
    getSummaryYear() {
      const endDate = this.reportFeeSummaryInfo.conditions.endDate || this.reportFeeSummaryInfo.conditions.startDate
      const year = Number((endDate || '').substring(0, 4))
      return year || new Date().getFullYear()
    },
    getSummaryEndDate(year) {
      return `${year}-12-31`
    },
    getAnnualTitle() {
      const summary = this.reportFeeSummaryInfo.annualSummary
      return `（${summary.startDate || `${summary.year}-01-01`} 至 ${summary.endDate || `${summary.year}-12-31`}）`
    },
    formatMoney(value) {
      return Number(value || 0).toFixed(2)
    },
    formatRate(received, receivable) {
      const total = Number(receivable || 0)
      if (total <= 0) {
        return '0.00%'
      }
      return `${(Number(received || 0) / total * 100).toFixed(2)}%`
    },
    async _loadStaffCommunitys() {
      try {
        const data = await queryCommunitys()
        this.reportFeeSummaryInfo.communitys = data.communitys
      } catch (error) {
        console.error('Failed to load communities:', error)
      }
    },
    async _listFeeConfigs() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.reportFeeSummaryInfo.conditions.communityId,
          isDefault: 'F'
        }

        const data = await queryFeeConfigs(params)
        this.reportFeeSummaryInfo.feeConfigs = data.feeConfigs
      } catch (error) {
        console.error('Failed to list fee configs:', error)
      }
    },
    _queryMethod() {
      this._listFees()
    },
    _resetMethod() {
      this.reportFeeSummaryInfo.conditions = {
        ...this.reportFeeSummaryInfo.conditions,
        roomNum: '',
        ownerName: '',
        link: '',
        feeTypeCd: '',
        floorName: '',
        floorId: '',
        unitId: '',
        configId: ''
      }
      this.reportFeeSummaryInfo.configIds = []
      this._listFees()
    },
    async _exportExcel() {
      try {
        const params = {
          ...this.reportFeeSummaryInfo.conditions,
          pagePath: 'reportFeeSummary'
        }

        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('Failed to export:', error)
        this.$message.error(this.$t('reportFeeSummary.exportFailed'))
      }
    },
    _changCommunity() {
      this._listFeeConfigs()
      this._listFees()
    }
  }
}
</script>

<style lang="scss" scoped>
.report-fee-summary-container {
  padding: 20px;

  .margin-top {
    margin-top: 20px;
  }

  .padding-r-0 {
    padding-right: 0;
  }

  .popover-show {
    margin-left: 10px;
    color: #409EFF;
  }

  .summary-subtitle {
    margin-left: 12px;
    color: #909399;
    font-size: 13px;
  }

  .summary-tip-icon {
    margin-left: 5px;
    color: #909399;
    cursor: pointer;
    font-size: 14px;
  }

  .summary-tip-icon:hover {
    color: #409EFF;
  }

.simple-summary-grid {
  display: grid;
  grid-template-columns: repeat(8, minmax(120px, 1fr));
  gap: 12px;
}

  .simple-summary-item {
    min-height: 82px;
    padding: 14px 16px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafbfc;
  }

  .summary-label {
    color: #606266;
    font-size: 13px;
    line-height: 18px;
  }

  .summary-value {
    margin-top: 10px;
    color: #303133;
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
  }

  .summary-value.warning {
    color: #e6a23c;
  }

  .summary-value.success {
    color: #67c23a;
  }

  .summary-value.danger {
    color: #f56c6c;
  }

  .el-checkbox {
    margin-right: 15px;
  }
}
</style>
